import CancelOrganisationInvitation from './CancelOrganisationInvitation';

export default CancelOrganisationInvitation;
